// @ts-strict-ignore
import { useTranslation } from "react-i18next";

import { Dropdown, DropdownButton, DropdownContent, DropdownItem } from "@aviary";
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";
import { l } from "@shared/locales/i18n";

import * as styles from "./CatalogSortDropdown.styles";

const SORT_TEXT_MAP = {
  RELEVANCE: {
    DESC: "BestMatch",
  },
  ALPHABETICAL: {
    ASC: "AlphabeticalAZ",
    DESC: "AlphabeticalZA",
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  MOST_PRESCRIBED: {
    DESC: "MostPrescribed",
  },
  PRICE: {
    ASC: "LeastExpensive",
    DESC: "MostExpensive",
  },
};

interface Props {
  isDisabled: boolean;
  isTransparent?: boolean;
  isFullWidth?: boolean;
  isEmerson?: boolean;
}

const CatalogSortDropdown = ({
  isDisabled,
  isFullWidth,
  isTransparent = true,
  isEmerson,
}: Props) => {
  const { t } = useTranslation();
  const { sortDirection, sortField, setSort } = useCatalogSearch();

  const handleMostPopular = () =>
    isEmerson ? l.sharedCatalog.resultSort.MostPopular : l.sharedCatalog.resultSort.MostRecommended;

  const getCurrentSort = () => {
    if (!sortField || sortField === "RELEVANCE") {
      return t(l.sharedCatalog.resultSort[SORT_TEXT_MAP.RELEVANCE.DESC]);
    } else if (sortField === "MOST_PRESCRIBED") {
      return t(handleMostPopular());
    } else {
      return t(l.sharedCatalog.resultSort[SORT_TEXT_MAP[sortField][sortDirection]]);
    }
  };

  return (
    <div css={styles.dropDownAlignment}>
      <Dropdown prefixText={t(l.sharedCommon.Sort)} disabled={isDisabled} isFullWidth={isFullWidth}>
        <DropdownButton
          disabled={isDisabled}
          css={!!isTransparent && styles.dropdownBtnTransparent}
        >
          {getCurrentSort()}
        </DropdownButton>
        <DropdownContent css={styles.dropdownContent}>
          <DropdownItem onSelect={() => setSort("RELEVANCE", "DESC")}>
            {t(l.sharedCatalog.resultSort[SORT_TEXT_MAP.RELEVANCE.DESC])}
          </DropdownItem>
          <DropdownItem onSelect={() => setSort("MOST_PRESCRIBED", "DESC")}>
            {t(handleMostPopular())}
          </DropdownItem>
          <DropdownItem onSelect={() => setSort("ALPHABETICAL", "ASC")}>
            {t(l.sharedCatalog.resultSort[SORT_TEXT_MAP.ALPHABETICAL.ASC])}
          </DropdownItem>
          <DropdownItem onSelect={() => setSort("ALPHABETICAL", "DESC")}>
            {t(l.sharedCatalog.resultSort[SORT_TEXT_MAP.ALPHABETICAL.DESC])}
          </DropdownItem>
          <DropdownItem onSelect={() => setSort("PRICE", "ASC")}>
            {t(l.sharedCatalog.resultSort[SORT_TEXT_MAP.PRICE.ASC])}
          </DropdownItem>
          <DropdownItem onSelect={() => setSort("PRICE", "DESC")}>
            {t(l.sharedCatalog.resultSort[SORT_TEXT_MAP.PRICE.DESC])}
          </DropdownItem>
        </DropdownContent>
      </Dropdown>
    </div>
  );
};
export { CatalogSortDropdown };
